import { get, post } from '../../utils/http';

export const AddClientToThirdPartyPositionMapping = (params) =>
  post(`/tools/addClientToThirdPartyPositionMapping`, params);

export const AddPositionsToAccountIds = (params) => post(`/tools/addPositionsToAccountIds`, params);

export const AddPositionToOrganization = (params) => post(`/tools/addPositionToOrganization`, params);

export const AlignEffectiveDateRates = (params) => post(`/tools/alignEffectiveDateRates`, params);

export const CopyPositionMappingClientToSuppliers = (params) =>
  post(`/tools/copyPositionMappingClientToSuppliers`, params);

export const CopyPositionMappingSupplierToClients = (params) =>
  post(`/tools/copyPositionMappingSupplierToClients`, params);

export const UploadJewishHolidays = (params) => post(`/tools/uploadJewishHolidays`, params);

export const GetLatestHolidayDate = () => get(`/tools/latestHolidayDate`);
